const PERMISSION_KEY= "core:billing";
const PAGE_URL = {
    BILLING_PAGE: "/admin/core/billing"
}

export {PERMISSION_KEY, PAGE_URL}

